/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment } from "react";
import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";

const UrlFieldDisplay = () => {
    
    // A URL is not a link with text. It is just a URL.
    const { field } = useCurrentDynamicField();
    const { values } = field || {};

    return (
        <FieldDisplayWrapper>
            {values &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const {
                        style = "field.style.body",
                        // format = 'field.format.url-as-text',
                        options,
                    } = settings || {};
                    const { openIn } = options || {};

                    return (
                        <Fragment key={index}>
                            {value &&
                                <a
                                    href={value}
                                    target={openIn === "_self" ? "_self" : "_blank"}
                                    rel='noreferrer'
                                >
                                    <DisplayTextOnly value={value} style={style} />
                                </a>
                            }
                        </Fragment>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
UrlFieldDisplay.displayName = "UrlFieldDisplay";
export { UrlFieldDisplay };
